import { ResultNextComponentMessageType } from '@data/types';
import React from 'react';

interface Props extends ResultNextComponentMessageType {}

const ResultNextComponentMessage: React.FC<Props> = ({ message }) => {
  return (
    <div className="w-1/2 flex justify-end text-white text-xs">
      <span className="translate-x-1/2 relative pdf-hide">
        {message}
        <span className="h-[8vh] w-[1px] bg-white block absolute right-1/2 translate-x-1/2">
          <span className="h-[5px] w-[5px] bg-white rounded block absolute bottom-0 right-1/2 translate-x-1/2">
            &nbsp;
          </span>
        </span>
      </span>
    </div>
  );
};

export default ResultNextComponentMessage;
